export default __webpack_public_path__ + "static/media/carousel1-back.cb91aac5.png";